
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

import Cheap from '@/common/components/UI/Cheap/index.vue'

import useAccount from '@/common/composable/useAccount'
import useAuth from '@/common/composable/useAuth'

export default defineComponent({
    components: { Cheap },
    setup() {
        const router = useRouter()

        const account = useAccount()
        const { removeAuthorization } = useAuth()

        const logout = () => {
            const answer = confirm('Вы действительно хотите выйти с учётной записи?')
            if (!answer) return

            removeAuthorization()
            account.reset()
            router.replace({ name: 'Auth' })
        }

        return {
            account,
            logout
        }
    }
})
